import React, { useEffect, useState } from "react";
import Seo from "@components/seo";
import BreadCrumb from "@components/common/breadcrumb";
import { Link } from "gatsby";
import { Row, Col, Container, Card } from "react-bootstrap";
import {
  WhatsappShareButton,
  LinkedinShareButton,
  EmailShareButton,
} from "react-share";
import TalkToUsPopup from "@components/common/talk-to-us-popup";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { addDoc, collection, getFirestore } from "firebase/firestore/lite";
import { useForm } from "react-hook-form";
import {
  addCount,
  collectionKeys,
  eyeIcon,
  getDocsFirebase,
  showErrMsg,
  showSuccssMsg,
  updateFirebaseCount,
} from "@core/helper/utils";
import Loading from "@components/common/loading";
import MoveForward from "@components/common/move-forward";
import Layout from "@components/layout";
// import { useLocation } from "@reach/router";
import { initializeApp } from "firebase/app";
import talk_to_us from "../images/talk_to_us.png";
import PhoneInput from "react-phone-input-2";

// import { Country } from "country-state-city";
// import noIMage from "@styles/assets/images/no-image.jpg";

const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;
const validationSchema = Yup.object().shape({
  name: Yup.string().label("Name").required(),
  email: Yup.string()
    .matches(emailRegex, "Invalid email address")
    .label("Email")
    .required(),
  mobile: Yup.string().label("Contact").required(),
  country: Yup.string().label("Country").optional(),
  content: Yup.string().label("Content").required(),
  service: Yup.string().label("Service").required(),
});

const BlogDetails = (props) => {
  const { pageContext } = props;
  const { blogData, firestore, metaInfo, slug } = pageContext;
  let firestoreNew = firestore?.data?.site?.siteMetadata?.firestore;
  // console.log(pageContext)
  // const location = useLocation();
  // const slugUrl = location.pathname.split("/")?.[2];

  const app = initializeApp(firestoreNew);
  const db = getFirestore(app);

  const currentUrl = typeof window !== "undefined" ? window.location.href : "";
  const [isTalkToUsShow, setIsTalkToUsShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const [count, setcount] = useState("");
  const [prevItem, setPrevItem] = useState(null);
  const [nextItem, setNextItem] = useState(null);
  const [number, setNumber] = useState("");
  const [headings, setHeadings] = useState([]);
  const [blogHtml, setBlogHtml] = useState("");
  const [selectedSection, setSelectedSection] = useState("");
  const pageTitle = `Checkout this blog : ${blogData?.title}`;
  // console.log("prevItem", prevItem)
  // console.log("nextItem", nextItem)

  useEffect(() => {
    if (typeof window !== "undefined" && pageContext?.blogData?.content) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(
        pageContext.blogData.content,
        "text/html"
      );
      const h2s = Array.from(doc.querySelectorAll("h2"));

      h2s.forEach((h2, index) => {
        const id = `section-${index}`;
        h2.setAttribute("id", id);
      });

      setHeadings(
        h2s.map((h2, index) => ({
          text: h2.textContent.trim(),
          id: `section-${index}`,
        }))
      );

      // Update blog content with new IDs
      setBlogHtml(doc.body.innerHTML);
    }
  }, [pageContext]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (visible.length > 0) {
          const currentId = visible[0].target.id;
          setSelectedSection(currentId);
        }
      },
      {
        rootMargin: "-20% 0px -60% 0px",
        threshold: [0.2, 0.5, 1],
      }
    );

    const h2s = document.querySelectorAll(".blog-const h2");
    h2s.forEach((h2) => observer.observe(h2));

    return () => {
      h2s.forEach((h2) => observer.unobserve(h2));
    };
  }, [blogHtml]);

  const breadcrumbLinks = [
    { text: "Home", link: "/" },
    { text: "Blogs", link: "/blog" },
    { text: blogData?.title, link: null },
  ];

  const handleOnChange = (value, country) => {
    setValue("country", country.countryCode, { shouldValidate: true });
    setValue("mobile", value, { shouldValidate: true });
    setNumber(value);
  };

  const handleTableContentChange = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 170;
      const y = element.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
      setSelectedSection(id);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const handleToggleTalkToUs = () => setIsTalkToUsShow(!isTalkToUsShow);

  const clickhandler = (e) => {
    let el = e.target;
    if (el.nodeName === "BUTTON") {
      handleToggleTalkToUs();
    } else {
      return false;
    }
  };

  const handleOnSubmit = async (values) => {
    const { name, email, country, content, mobile } = values;
    const payload = {
      name,
      email,
      country,
      content,
      mobile,
      date: new Date(),
    };
    setLoading(true);
    try {
      const clients = collection(db, collectionKeys.CLIENTS);
      await addDoc(clients, payload);
      handleToggleTalkToUs();
      reset();
      setNumber("");
      setLoading(false);
      setTimeout(() => {
        showSuccssMsg("We will contact/talk to you soon");
      }, 500);
    } catch (e) {
      showErrMsg("Error adding document");
      setLoading(false);
    }
  };

  useEffect(() => {
    const loadBlogsList = async (slug) => {
      // console.log(slug);
      try {
        const { blogs } = pageContext;
        // console.log(blogs)
        const currentItemIndex = blogs?.findIndex(
          (item) => item?.slug === slug
        );
        // console.log(currentItemIndex)
        const hasNextItem = currentItemIndex < blogs.length - 1;
        const hasPrevItem = currentItemIndex > 0;
        // console.log(hasNextItem)
        const nextItem = hasNextItem ? blogs?.[currentItemIndex + 1] : null;
        const prevItem = hasPrevItem ? blogs?.[currentItemIndex - 1] : null;
        setPrevItem(prevItem);
        setNextItem(nextItem);
      } catch (err) {
        console.log("err:;", err);
      }
    };

    const updateBlogViewCount = async (slug) => {
      try {
        let querySnapshot = await getDocsFirebase(db, slug);
        if (querySnapshot?.docs?.length === 0) {
          addCount(db, slug);
        } else {
          // return;
          querySnapshot?.forEach(async (doc) => {
            const blogId = doc.id;
            if (blogId) {
              const count = await updateFirebaseCount(blogId, db, slug);
              setcount(count?.count);
            }
          });
        }
      } catch (err) {
        console.log("err updateBlogViewCount:", err);
      }
    };

    if (isMounted) {
      if (pageContext) {
        loadBlogsList(pageContext?.blogData?.slug);
        updateBlogViewCount(pageContext?.blogData?.slug);
      }
    }
  }, [isMounted, pageContext, db]);

  useEffect(() => {
    setIsMounted(true);
  }, []);
  // console.log("BlogDetails-Head-pageContext::", JSON.stringify(pageContext));
  // const { metaInfo, slug } = pageContext;
  // console.log("blogData ", blogData)
  // console.log("slug ", slug)
  return (
    <Layout db={db}>
      <Seo
        title={blogData?.title}
        metaTitle={blogData?.title}
        description={blogData?.short_description}
        ogTitle={blogData?.title}
        ogType={blogData?.ogType}
        ogDescription={blogData?.short_description}
        twitterTitle={blogData?.title}
        twitterDescription={blogData?.short_description}
        image={""}
        slug={slug}
      ></Seo>
      <BreadCrumb items={breadcrumbLinks} />
      <div className="blog-bg"></div>
      <div className="defi_blog_page">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="defi_content">
                <h1 className="text-white blog-title">{blogData?.title}</h1>
                <div className="blog_entry_details">
                  <span className="d-flex text-white justify-content-start">
                    <p className="mb-0 text-white">
                      {eyeIcon()} {count}
                    </p>
                  </span>
                  <div
                    style={{
                      display: "flex",
                      gap: "15px",
                      alignItems: "center",
                    }}
                  >
                    <span
                      style={{
                        display: "flex",
                        gap: "8px",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="19"
                          height="20"
                          viewBox="0 0 19 20"
                          fill="none"
                        >
                          <path
                            d="M15.988 14.1365C15.2249 14.1365 14.5422 14.4378 14.0201 14.9096L6.86147 10.743C6.91167 10.512 6.95183 10.2811 6.95183 10.0402C6.95183 9.7992 6.91167 9.56827 6.86147 9.33735L13.9398 5.21084C14.482 5.71285 15.1948 6.0241 15.988 6.0241C17.6546 6.0241 19 4.67871 19 3.01205C19 1.34538 17.6546 0 15.988 0C14.3213 0 12.9759 1.34538 12.9759 3.01205C12.9759 3.25301 13.0161 3.48394 13.0663 3.71486L5.98798 7.84137C5.44581 7.33936 4.73296 7.02811 3.93978 7.02811C2.27312 7.02811 0.927734 8.37349 0.927734 10.0402C0.927734 11.7068 2.27312 13.0522 3.93978 13.0522C4.73296 13.0522 5.44581 12.741 5.98798 12.239L13.1366 16.4157C13.0864 16.6265 13.0562 16.8474 13.0562 17.0683C13.0562 18.6847 14.3715 20 15.988 20C17.6044 20 18.9197 18.6847 18.9197 17.0683C18.9197 15.4518 17.6044 14.1365 15.988 14.1365Z"
                            fill="white"
                          ></path>
                        </svg>
                      </span>
                      <span className="ms-2">
                        {" "}
                        <p className="mb-0 blog_share">Share:</p>
                      </span>
                    </span>
                    <WhatsappShareButton url={currentUrl} title={pageTitle}>
                      <div className="expand_icon">
                        <svg
                          className="default_icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                        >
                          <path
                            d="M26.4753 7.74762C22.443 1.49647 14.1853 -0.355725 7.79907 3.5223C1.56721 7.40033 -0.439334 15.851 3.59304 22.0828L3.92104 22.5845L2.57048 27.6394L7.62542 26.2888L8.12706 26.6168C10.3072 27.7937 12.6804 28.469 15.0342 28.469C17.5617 28.469 20.0891 27.7937 22.2693 26.4432C28.5012 22.3915 30.3534 14.1145 26.4753 7.70903V7.74762ZM22.9446 20.7516C22.2693 21.7548 21.4204 22.4301 20.2435 22.6037C19.5682 22.6037 18.7193 22.9317 15.3622 21.6005C12.5067 20.2499 10.1336 18.0504 8.45505 15.523C7.45178 14.3461 6.93085 12.8219 6.7765 11.2977C6.7765 9.9471 7.27814 8.77018 8.12706 7.92126C8.45505 7.59327 8.80234 7.41963 9.13033 7.41963H9.97925C10.3072 7.41963 10.6545 7.41963 10.8282 8.0949C11.1562 8.94383 12.0051 10.9697 12.0051 11.1433C12.1787 11.3169 12.1016 12.6096 11.3298 13.3428C10.9053 13.8251 10.8282 13.8444 11.0018 14.1917C11.6771 15.195 12.526 16.2175 13.3556 17.0665C14.3589 17.9154 15.3815 18.5907 16.5584 19.0923C16.8864 19.2659 17.2337 19.2659 17.4073 18.9187C17.581 18.5907 18.4106 17.7417 18.7579 17.3945C19.0859 17.0665 19.2595 17.0665 19.6068 17.2208L22.3079 18.5714C22.6359 18.745 22.9832 18.8994 23.1568 19.073C23.3305 19.5746 23.3305 20.2499 22.9832 20.7516H22.9446Z"
                            stroke="white"
                          />
                        </svg>
                        <svg
                          className="hover_icon"
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="0.5"
                            y="0.5"
                            width="31"
                            height="31"
                            rx="15.5"
                            fill="white"
                          ></rect>
                          <path
                            d="M16 1C24.2845 1 31 7.7155 31 16C31 24.2845 24.2845 31 16 31C13.3492 31.0043 10.745 30.3027 8.45502 28.9675L1.00602 31L3.03402 23.548C1.69766 21.2573 0.995592 18.652 1.00002 16C1.00002 7.7155 7.71552 1 16 1ZM10.888 8.95L10.588 8.962C10.3938 8.97382 10.204 9.02485 10.03 9.11199C9.8673 9.20414 9.71876 9.31933 9.58902 9.45399C9.40902 9.6235 9.30702 9.77049 9.19752 9.91299C8.6427 10.6343 8.34398 11.52 8.34852 12.43C8.35152 13.165 8.54352 13.8805 8.84352 14.5495C9.45702 15.9025 10.4665 17.335 11.7985 18.6625C12.1195 18.982 12.4345 19.303 12.7735 19.6015C14.4286 21.0587 16.4009 22.1095 18.5335 22.6705L19.3855 22.801C19.663 22.816 19.9405 22.795 20.2195 22.7815C20.6564 22.7589 21.0829 22.6406 21.469 22.435C21.6654 22.3338 21.8571 22.2237 22.0435 22.105C22.0435 22.105 22.108 22.063 22.231 21.97C22.4335 21.82 22.558 21.7135 22.726 21.538C22.8505 21.409 22.9585 21.2575 23.041 21.085C23.158 20.8405 23.275 20.374 23.323 19.9855C23.359 19.6885 23.3485 19.5265 23.344 19.426C23.338 19.2655 23.2045 19.099 23.059 19.0285L22.186 18.637C22.186 18.637 20.881 18.0685 20.083 17.7055C19.9995 17.669 19.91 17.6482 19.819 17.644C19.7164 17.6334 19.6127 17.645 19.5149 17.6779C19.4171 17.7107 19.3275 17.7641 19.252 17.8345C19.2445 17.8315 19.144 17.917 18.0595 19.231C17.9973 19.3146 17.9115 19.3778 17.8132 19.4126C17.7149 19.4473 17.6085 19.452 17.5075 19.426C17.4098 19.3998 17.3141 19.3667 17.221 19.327C17.035 19.249 16.9705 19.219 16.843 19.165C15.9821 18.7893 15.185 18.2817 14.4805 17.6605C14.2915 17.4955 14.116 17.3155 13.936 17.1415C13.3459 16.5763 12.8316 15.937 12.406 15.2395L12.3175 15.097C12.2539 15.0012 12.2026 14.8979 12.1645 14.7895C12.1075 14.569 12.256 14.392 12.256 14.392C12.256 14.392 12.6205 13.993 12.79 13.777C12.955 13.567 13.0945 13.363 13.1845 13.2175C13.3615 12.9325 13.417 12.64 13.324 12.4135C12.904 11.3875 12.469 10.366 12.022 9.35199C11.9335 9.15099 11.671 9.00699 11.4325 8.97849C11.3515 8.96949 11.2705 8.96049 11.1895 8.95449C10.9881 8.94449 10.7862 8.94649 10.585 8.96049L10.8865 8.94849L10.888 8.95Z"
                            fill="#7534FC"
                          ></path>
                          <rect
                            x="0.5"
                            y="0.5"
                            width="31"
                            height="31"
                            rx="15.5"
                            stroke="#7534FC"
                          ></rect>
                        </svg>
                      </div>
                    </WhatsappShareButton>
                    <LinkedinShareButton url={currentUrl} title={pageTitle}>
                      <div className="expand_icon">
                        <svg
                          className="default_icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_1007_4392)">
                            <path
                              d="M15 1C7.26792 1 1 7.26792 1 15C1 22.7321 7.26792 29 15 29C22.7321 29 29 22.7321 29 15C29 7.26792 22.7321 1 15 1ZM11.5729 20.8027H8.73792V11.6794H11.5729V20.8027ZM10.1379 10.5594C9.2425 10.5594 8.66354 9.925 8.66354 9.14042C8.66354 8.33979 9.26 7.72437 10.1744 7.72437C11.0887 7.72437 11.6487 8.33979 11.6662 9.14042C11.6662 9.925 11.0887 10.5594 10.1379 10.5594ZM21.9271 20.8027H19.0921V15.7467C19.0921 14.5698 18.6808 13.7706 17.6556 13.7706C16.8725 13.7706 16.4073 14.3117 16.2017 14.8323C16.1258 15.0175 16.1069 15.28 16.1069 15.541V20.8012H13.2704V14.5888C13.2704 13.4498 13.234 12.4975 13.196 11.6779H15.6592L15.789 12.9452H15.8458C16.2192 12.3502 17.1335 11.4723 18.6633 11.4723C20.5285 11.4723 21.9271 12.7221 21.9271 15.4083V20.8027Z"
                              stroke="white"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_1007_4392">
                              <rect width="30" height="30" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        <svg
                          className="hover_icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="34"
                          height="34"
                          viewBox="0 0 34 34"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_310_734)">
                            <rect
                              x="2"
                              y="2"
                              width="30"
                              height="30"
                              rx="15"
                              fill="white"
                            ></rect>
                            <path
                              d="M17 2C8.71563 2 2 8.71563 2 17C2 25.2844 8.71563 32 17 32C25.2844 32 32 25.2844 32 17C32 8.71563 25.2844 2 17 2ZM13.3281 23.2172H10.2906V13.4422H13.3281V23.2172ZM11.7906 12.2422C10.8313 12.2422 10.2109 11.5625 10.2109 10.7219C10.2109 9.86406 10.85 9.20469 11.8297 9.20469C12.8094 9.20469 13.4094 9.86406 13.4281 10.7219C13.4281 11.5625 12.8094 12.2422 11.7906 12.2422ZM24.4219 23.2172H21.3844V17.8C21.3844 16.5391 20.9438 15.6828 19.8453 15.6828C19.0063 15.6828 18.5078 16.2625 18.2875 16.8203C18.2063 17.0188 18.1859 17.3 18.1859 17.5797V23.2156H15.1469V16.5594C15.1469 15.3391 15.1078 14.3188 15.0672 13.4406H17.7063L17.8453 14.7984H17.9063C18.3063 14.1609 19.2859 13.2203 20.925 13.2203C22.9234 13.2203 24.4219 14.5594 24.4219 17.4375V23.2172Z"
                              fill="#7534FC"
                            ></path>
                          </g>
                          <rect
                            x="1"
                            y="1"
                            width="32"
                            height="32"
                            rx="16"
                            stroke="#7534FC"
                            strokeWidth="2"
                          ></rect>
                          <defs>
                            <clipPath id="clip0_310_734">
                              <rect
                                x="2"
                                y="2"
                                width="30"
                                height="30"
                                rx="15"
                                fill="white"
                              ></rect>
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </LinkedinShareButton>
                    <EmailShareButton url={currentUrl} subject={pageTitle}>
                      <div className="expand_icon">
                        <svg
                          className="default_icon"
                          xmlns="http://www.w3.org/2000/svg"
                          width="30"
                          height="30"
                          viewBox="0 0 30 30"
                          fill="none"
                        >
                          <rect
                            x="0.6"
                            y="0.6"
                            width="28.8"
                            height="28.8"
                            rx="14.4"
                            stroke="white"
                            strokeWidth="1.2"
                          />
                          <path
                            d="M20.4276 9.0791C21.5724 9.0791 22.5 10.0067 22.5 11.1515V18.8488C22.5 19.9936 21.5724 20.9212 20.4276 20.9212H9.57237C9.02274 20.9212 8.49563 20.7029 8.10698 20.3142C7.71834 19.9256 7.5 19.3985 7.5 18.8488V11.1515C7.5 10.0067 8.42763 9.0791 9.57237 9.0791H20.4276ZM21.5132 12.7703L15.2376 16.2219C15.1731 16.2574 15.1014 16.278 15.0278 16.2821C14.9542 16.2863 14.8807 16.2739 14.8125 16.2459L14.7624 16.2223L8.48684 12.7699V18.8488C8.48684 19.1367 8.60121 19.4128 8.80479 19.6164C9.00836 19.82 9.28447 19.9344 9.57237 19.9344H20.4276C20.7155 19.9344 20.9916 19.82 21.1952 19.6164C21.3988 19.4128 21.5132 19.1367 21.5132 18.8488V12.7703ZM20.4276 10.0659H9.57237C9.28447 10.0659 9.00836 10.1803 8.80479 10.3839C8.60121 10.5875 8.48684 10.8636 8.48684 11.1515V11.6445L15 15.2263L21.5132 11.6441V11.1515C21.5132 10.8636 21.3988 10.5875 21.1952 10.3839C20.9916 10.1803 20.7155 10.0659 20.4276 10.0659Z"
                            fill="white"
                          />
                        </svg>
                        <svg
                          className="hover_icon"
                          width="34"
                          height="34"
                          viewBox="0 0 34 34"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <rect
                            x="1.4"
                            y="1.4"
                            width="31.2"
                            height="31.2"
                            rx="15.6"
                            fill="#7534FC"
                          ></rect>
                          <path
                            d="M24.5 14.2275V20.8488C24.5 21.9936 23.5724 22.9212 22.4276 22.9212H11.5724C11.0227 22.9212 10.4956 22.7029 10.107 22.3142C9.71834 21.9256 9.5 21.3985 9.5 20.8488V14.2275L16.7624 18.2223C16.9104 18.3036 17.09 18.3036 17.2376 18.2223L24.5 14.2275ZM22.4276 11.0791C22.9686 11.0792 23.4881 11.2907 23.8752 11.6687C24.2623 12.0466 24.4862 12.5609 24.4992 13.1017L17 17.2267L9.50079 13.1013L9.50158 13.0658C9.52369 12.5314 9.75153 12.0263 10.1375 11.656C10.5234 11.2858 11.0375 11.0791 11.5724 11.0791H22.4276Z"
                            fill="white"
                          ></path>
                          <rect
                            x="1.4"
                            y="1.4"
                            width="31.2"
                            height="31.2"
                            rx="15.6"
                            stroke="#7534FC"
                            strokeWidth="1.2"
                          ></rect>
                        </svg>
                      </div>
                    </EmailShareButton>
                  </div>
                </div>
                <img src={`/images/blogs/${blogData?.slug}.png`} style={{
                  width: "100%",
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "contain",
                  backgroundPosition: "center",
                }} className="blog_details_img_sec" alt={`${blogData.image_alt}`} />
                <div className="select_container">
                  <select
                    className="form_select"
                    onChange={(e) => handleTableContentChange(e.target.value)}
                    value={selectedSection}
                  >
                    <option disabled value="">
                      Table Of Contents
                    </option>
                    {headings.map((heading, idx) => (
                      <option key={idx} value={heading.id}>
                        {heading.text}
                      </option>
                    ))}
                  </select>
                </div>
                <div
                  onKeyDown={(e) => { }}
                  onClick={clickhandler}
                  className="blog-const"
                  dangerouslySetInnerHTML={{ __html: blogHtml }}
                ></div>
              </div>
            </Col>
          </Row>
        </Container>
        <div className="custom_margin_top">
          <Container>
            <Row
              className="d-flex justify-content-evenly"
              style={{
                rowGap: "10px",
              }}
            >
              {prevItem && (
                <Col md={6} lg={6} xl={4}>
                  <Link to={prevItem?.isNewBlogUrlFormat && prevItem?.isNewBlogUrlFormat === true ? `/${prevItem?.slug}` : `/blog/${prevItem?.slug}`}>
                    <Card className="blog_prev_card">
                      <img
                        src={`/images/blogs/${prevItem?.slug}.png`}
                        alt={"blog-image"}
                        className="jt_blog_img z-3 card-img"
                      />
                      <Card.Body>
                        <Card.Title
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                          }}
                          className="mb-3 text-white fw-semibold lh-sm fs-1 z-3 position-relative"
                        >
                          {prevItem?.title}
                        </Card.Title>
                        <Card.Text
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                          }}
                          className="cta-text text-white mb-5 fs-4 z-3 position-relative"
                        >
                          {prevItem?.short_description}
                        </Card.Text>

                        <div className="d-flex justify-content-center align-items-center next_prev_buttons position-relative z-3">
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 50 50"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M25 0C20.0555 0 15.222 1.46622 11.1108 4.21326C6.99952 6.96029 3.79521 10.8648 1.90302 15.4329C0.0108317 20.0011 -0.484251 25.0277 0.480379 29.8773C1.44501 34.7268 3.82603 39.1813 7.32234 42.6777C10.8187 46.174 15.2732 48.555 20.1227 49.5196C24.9723 50.4842 29.9989 49.9892 34.5671 48.097C39.1352 46.2048 43.0397 43.0005 45.7867 38.8892C48.5338 34.778 50 29.9445 50 25C49.9922 18.372 47.3558 12.0176 42.6691 7.33093C37.9823 2.6442 31.628 0.00778394 25 0ZM25 47.0588C20.6372 47.0588 16.3723 45.7651 12.7448 43.3412C9.11723 40.9174 6.28989 37.4723 4.62031 33.4415C2.95073 29.4108 2.5139 24.9755 3.36504 20.6965C4.21619 16.4175 6.31708 12.487 9.40207 9.40205C12.487 6.31707 16.4176 4.21617 20.6965 3.36503C24.9755 2.51389 29.4108 2.95072 33.4416 4.6203C37.4723 6.28988 40.9174 9.11722 43.3412 12.7448C45.7651 16.3723 47.0588 20.6372 47.0588 25C47.0523 30.8484 44.7262 36.4553 40.5908 40.5908C36.4554 44.7262 30.8484 47.0523 25 47.0588ZM36.2745 25C36.2745 25.39 36.1196 25.7641 35.8438 26.0399C35.568 26.3156 35.1939 26.4706 34.8039 26.4706H18.7476L24.0784 31.8039C24.2229 31.9385 24.3388 32.1009 24.4192 32.2813C24.4996 32.4617 24.5428 32.6564 24.5463 32.8539C24.5497 33.0513 24.5134 33.2475 24.4395 33.4306C24.3655 33.6137 24.2554 33.78 24.1158 33.9197C23.9761 34.0593 23.8098 34.1694 23.6267 34.2434C23.4436 34.3173 23.2474 34.3537 23.05 34.3502C22.8525 34.3467 22.6578 34.3035 22.4774 34.2231C22.297 34.1427 22.1346 34.0268 22 33.8823L14.1569 26.0392C13.8815 25.7635 13.7268 25.3897 13.7268 25C13.7268 24.6103 13.8815 24.2365 14.1569 23.9608L22 16.1176C22.2788 15.8579 22.6475 15.7165 23.0285 15.7232C23.4095 15.7299 23.773 15.8842 24.0424 16.1537C24.3118 16.4231 24.4662 16.7866 24.4729 17.1676C24.4796 17.5486 24.3382 17.9173 24.0784 18.1961L18.7476 23.5294H34.8039C35.1939 23.5294 35.568 23.6843 35.8438 23.9601C36.1196 24.2359 36.2745 24.61 36.2745 25Z"
                              fill="#FFFFFF"
                            ></path>
                          </svg>
                        </div>
                      </Card.Body>
                      <div className="blog_prev_hover_bg "></div>
                    </Card>
                  </Link>
                </Col>
              )}
              {nextItem && (
                <Col md={6} lg={6} xl={4}>
                  <Link to={nextItem?.isNewBlogUrlFormat && nextItem?.isNewBlogUrlFormat === true ? `/${nextItem?.slug}` : `/blog/${nextItem?.slug}`}>
                    <Card className="blog_next_card">
                      <img
                        src={`/images/blogs/${nextItem?.slug}.png`}
                        alt={"blog-image"}
                        className="jt_blog_img z-3 card-img"
                      />
                      <Card.Body>
                        <Card.Title
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                          }}
                          className="mb-3 text-white fw-semibold lh-sm fs-1 z-3 position-relative"
                        >
                          {nextItem?.title}
                        </Card.Title>
                        <Card.Text
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                          }}
                          className="cta-text text-white mb-5 fs-4 z-3 position-relative"
                        >
                          {nextItem?.short_description}
                        </Card.Text>
                        <div className="d-flex justify-content-center align-items-center next_prev_buttons position-relative z-3">
                          <svg
                            width="50"
                            height="50"
                            viewBox="0 0 50 50"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M25 0C20.0555 0 15.222 1.46622 11.1108 4.21326C6.99952 6.96029 3.79521 10.8648 1.90302 15.4329C0.0108317 20.0011 -0.484251 25.0277 0.480379 29.8773C1.44501 34.7268 3.82603 39.1813 7.32234 42.6777C10.8187 46.174 15.2732 48.555 20.1227 49.5196C24.9723 50.4842 29.9989 49.9892 34.5671 48.097C39.1352 46.2048 43.0397 43.0005 45.7867 38.8892C48.5338 34.778 50 29.9445 50 25C49.9922 18.372 47.3558 12.0176 42.6691 7.33093C37.9823 2.6442 31.628 0.00778394 25 0ZM25 47.0588C20.6372 47.0588 16.3723 45.7651 12.7448 43.3412C9.11723 40.9174 6.28989 37.4723 4.62031 33.4415C2.95073 29.4108 2.5139 24.9755 3.36504 20.6965C4.21619 16.4175 6.31708 12.487 9.40207 9.40205C12.487 6.31707 16.4176 4.21617 20.6965 3.36503C24.9755 2.51389 29.4108 2.95072 33.4416 4.6203C37.4723 6.28988 40.9174 9.11722 43.3412 12.7448C45.7651 16.3723 47.0588 20.6372 47.0588 25C47.0523 30.8484 44.7262 36.4553 40.5908 40.5908C36.4554 44.7262 30.8484 47.0523 25 47.0588ZM35.8431 23.9608C36.1185 24.2365 36.2732 24.6103 36.2732 25C36.2732 25.3897 36.1185 25.7635 35.8431 26.0392L28 33.8823C27.7212 34.1421 27.3525 34.2835 26.9715 34.2768C26.5905 34.2701 26.227 34.1157 25.9576 33.8463C25.6882 33.5769 25.5338 33.2134 25.5271 32.8324C25.5204 32.4514 25.6618 32.0827 25.9216 31.8039L31.2525 26.4706H15.1961C14.8061 26.4706 14.432 26.3156 14.1562 26.0399C13.8804 25.7641 13.7255 25.39 13.7255 25C13.7255 24.61 13.8804 24.2359 14.1562 23.9601C14.432 23.6843 14.8061 23.5294 15.1961 23.5294H31.2525L25.9216 18.1961C25.6618 17.9173 25.5204 17.5486 25.5271 17.1676C25.5338 16.7866 25.6882 16.4231 25.9576 16.1537C26.227 15.8842 26.5905 15.7299 26.9715 15.7232C27.3525 15.7165 27.7212 15.8579 28 16.1176L35.8431 23.9608Z"
                              fill="#ffffff"
                            />
                          </svg>
                        </div>
                      </Card.Body>
                      <div
                        className="blog_next_hover_bg
                    "
                      ></div>
                    </Card>
                  </Link>
                </Col>
              )}
            </Row>
          </Container>
        </div>
        <div className="custom_margin_top">
          <Container>
            <Row className="d-flex align-items-center justify-content-center blog-custom-width">
              <a className="blog_btn" href="/blog/">
                Read More Blogs{" "}
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    strokeWidth="1.5"
                    stroke="#fff"
                    width={35}
                    height={35}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
                    />
                  </svg>
                </span>
              </a>
            </Row>
          </Container>
        </div>
      </div>
      <MoveForward db={db} />
      <TalkToUsPopup
        show={isTalkToUsShow}
        onHide={() => handleToggleTalkToUs()}
        closeButton={true}
        size={"lg"}
        backdrop="static"
        keyboard={false}
      >
        <div className="talk_us_wrapper">
          <Row>
            <Col lg={7} className="order-2 order-xl-1">
              <div className="talk_us_left">
                <form
                  className="form_field"
                  onSubmit={handleSubmit(handleOnSubmit)}
                >
                  <div>
                    <input
                      type="text"
                      placeholder="Enter Your Name"
                      className="talk_input"
                      {...register("name")}
                    />
                    <p className="text-danger mb-0">{errors.name?.message}</p>
                  </div>
                  <div>
                    <input
                      type="mail"
                      placeholder="Enter Your Email"
                      className="talk_input"
                      {...register("email")}
                    />
                    <p className="text-danger mb-0">{errors.email?.message}</p>
                  </div>
                  <div>
                    <PhoneInput
                      className="talk_phone_input"
                      country={"us"}
                      value={number}
                      enableSearch
                      searchPlaceholder=""
                      {...register("mobile")}
                      onChange={handleOnChange}
                    />
                    <p className="text-danger mb-0">{errors.mobile?.message}</p>
                  </div>

                  <div className="login__field">
                    <select
                      className="talk_input round"
                      {...register("service")}
                    >
                      <option value="">Select your services</option>
                      <option value="crypto exchange development">
                        Crypto Exchange Development
                      </option>
                      <option value="nft marketplace development">
                        NFT Marketplace Development
                      </option>
                      <option value="defi development">DeFi Development</option>
                      <option value="metaverse development">
                        Metaverse Development
                      </option>
                      <option value="blockchain solutions">
                        Blockchain Solutions
                      </option>
                      <option value="web 3.0 development">
                        Web 3.0 Development
                      </option>
                      <option value="crypto wallet development">
                        Crypto Wallet Development
                      </option>
                      <option value="custom software development">
                        Custom Software Development
                      </option>
                      <option value="mobile app development services">
                        Mobile App Development Services
                      </option>
                      <option value="artificial intelligence solutions">
                        Artificial Intelligence Solutions
                      </option>
                      <option value="others"> Others</option>
                    </select>
                    <span className="error_msg_text">
                      <p className="text-danger mb-0">
                        {errors.service?.message}
                      </p>
                    </span>
                  </div>
                  <div>
                    <textarea
                      placeholder="Type Content Here..."
                      rows={5}
                      {...register("content")}
                    ></textarea>
                    <p className="text-danger mb-0">
                      {errors.content?.message}
                    </p>
                  </div>
                  <button
                    type="submit"
                    disabled={loading}
                    className="button login__submit login_new"
                  >
                    <span className="button__text">
                      {" "}
                      Submit {loading && <Loading />}
                    </span>
                    <i className="button__icon fas fa-chevron-right"></i>
                  </button>
                </form>
              </div>
            </Col>
            <Col lg={5} className="order-1 order-xl-2">
              <div className="talk_us_right">
                <h2>Contact Us</h2>
                <p>
                  Feel free to reach out to Justtry Technologies for any
                  inquiries or support. Our team is here to assist you!
                </p>
              </div>
            </Col>
          </Row>
          <div className="talk_to_us_image d-lg-block d-none">
            <img src={talk_to_us} alt="new-img" />
          </div>
        </div>
      </TalkToUsPopup>

      {/* <TalkToUsPopup
        show={isTalkToUsShow}
        onHide={handleToggleTalkToUs}
        closeButton={true}
        size={"lg"}
        backdrop="static"
        keyboard={false}
      >
        <div className="screen__content">
          <form onSubmit={handleSubmit(handleOnSubmit)} className="login">
            <div className="login__field">
              <i className="login__icon fas fa-user"></i>
              <input
                type="text"
                className="login__input"
                {...register("name")}
                placeholder="Your Name"
              />
              <p className="text-danger mb-0">{errors.name?.message}</p>
            </div>
            <div className="login__field">
              <i className="login__icon fas fa-lock"></i>
              <input
                type="email"
                className="login__input"
                {...register("email")}
                placeholder="Email"
              />
              <p className="text-danger mb-0">{errors.email?.message}</p>
            </div>
            <div className="login__field">
              <i className="login__icon fas fa-lock"></i>
              <input
                type="text"
                className="login__input"
                placeholder="Teams / Mobile / Whatsapp"
                {...register("mobile")}
              />
              <p className="text-danger mb-0">{errors.mobile?.message}</p>
            </div>
            <div className="login__field">
              <select className="login__input" {...register("service")}>
                <option value="">Select your services</option>
                <option value="crypto exchange development">
                  Crypto Exchange Development
                </option>
                <option value="nft marketplace development">
                  NFT Marketplace Development
                </option>
                <option value="defi development">DeFi Development</option>
                <option value="metaverse development">
                  Metaverse Development
                </option>
                <option value="blockchain solutions">
                  Blockchain Solutions
                </option>
                <option value="web 3.0 development">Web 3.0 Development</option>
                <option value="crypto wallet development">
                  Crypto Wallet Development
                </option>
                <option value="custom software development">
                  Custom Software Development
                </option>
                <option value="mobile app development services">
                  Mobile App Development Services
                </option>
                <option value="artificial intelligence solutions">
                  Artificial Intelligence Solutions
                </option>
                <option value="others"> Others</option>
              </select>
              <p className="text-danger mb-0">{errors.service?.message}</p>
            </div>
            <div className="login__field">
              <i className="login__icon fas fa-lock"></i>
              <select className="login__input" {...register("country")}>
                <option value="">Select Country</option>
                {countries.map((ele, ind) => (
                  <option key={ind} value={ele.isoCode}>
                    {ele.name}
                  </option>
                ))}
              </select>
              <p className="text-danger mb-0">{errors.country?.message}</p>
            </div>
            <div className="login__field">
              <i className="login__icon fas fa-lock"></i>
              <textarea
                id="content"
                placeholder="Type content here"
                rows={5}
                className="login__input"
                {...register("content")}
                maxLength={500}
              ></textarea>
              <p className="text-danger mb-0">{errors.content?.message}</p>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="button login__submit"
            >
              <span className="button__text">
                {" "}
                Submit {loading && <Loading />}
              </span>
              <i className="button__icon fas fa-chevron-right"></i>
            </button>
          </form>
        </div>
        <div className="screen__background">
          <span className="screen__background__shape screen__background__shape4"></span>
          <span className="screen__background__shape screen__background__shape3"></span>
          <span className="screen__background__shape screen__background__shape2"></span>
          <span className="screen__background__shape screen__background__shape1"></span>
        </div>
      </TalkToUsPopup> */}
    </Layout>
  );
};

// export const Head = (props) => {
//   const { pageContext } = props;
//   // console.log("BlogDetails-Head-pageContext::", JSON.stringify(pageContext));
//   const { metaInfo, slug } = pageContext;
//   console.log("metaInfo ", metaInfo)
//   console.log("slug ", slug)
//   return (
//     <Seo
//       title={metaInfo?.title}
//       metaTitle={metaInfo?.metaTitle}
//       description={metaInfo?.description}
//       ogTitle={metaInfo?.ogTitle}
//       ogType={metaInfo?.ogType}
//       ogDescription={metaInfo?.ogDescription}
//       twitterTitle={metaInfo?.twitterTitle}
//       twitterDescription={metaInfo?.twitterDescription}
//       image={""}
//       slug={slug}
//     ></Seo>
//   );
// };

export default BlogDetails;
